import { LatLngBounds, latLngBounds, latLng, LatLng } from "leaflet";
import { IMeasurementPoint } from "./models";

export default class MapState {
  mapCenter: LatLng = latLng(18.650389, -91.822165);
  mapZoom: number = 10;
  targetsTagsZoomLevel: number = 13;
  platformsTagsZoomLevel: number = 14;
  baseLayer: string = "osm";
  selectedFeatures: string[] = ["fixedPlatforms", "mobilePlatforms"];
  selectedTargets: string[] = ["vessels", "sars"];
  measurementPoints: IMeasurementPoint[] = [];
  measurementActivated: boolean = false;
  measurementNauticalUnits: boolean = true;
  bbox: LatLngBounds = latLngBounds(
    latLng(17.821916, -94.460449),
    latLng(21.330315, -89.637451)
  );
  totalDistance: number = 0;
}
